import PropTypes from 'prop-types';
import LinkedFiles from './LinkedFiles';
import { useIntl } from 'react-intl';

export const SupplementalGuidance = ({ guidance, assetType, assetTypeId }) => {
    const intl = useIntl();
    return (
        <>
            <h3
                className="govuk-heading-s govuk-!-margin-top-2 govuk-!-margin-bottom-2"
                data-testid="supplementaryDataTab.externalResourcesGuidanceHeading">
                {intl.formatMessage({ id: 'supplementaryDataTab.externalResourcesGuidance' })}
            </h3>
            {guidance?.description && <p className="govuk-body" data-testid='guidance.data.description'>{guidance.description}</p>}
            {guidance?.additionalInformation &&
                <p className="govuk-body" data-testid='guidance.data.additionalInformation'>{guidance.additionalInformation}</p>}
            <LinkedFiles
                linkedFiles={guidance?.linkedFiles}
                assetType={assetType}
                assetTypeId={assetTypeId}>
            </LinkedFiles>
            <hr className="govuk-section-break govuk-section-break--m govuk-section-break--visible"/>
        </>
    );
};

SupplementalGuidance.propTypes = {
    guidance: PropTypes.object,
    assetType: PropTypes.string.isRequired,
    assetTypeId: PropTypes.string.isRequired
};
